import { Box, Typography } from "@mui/material";
import { styledComponent } from "../utils/styled";
import { getFileTypeIcon } from "../utils/fileTypeUtils";

const ChipRoot = styledComponent(Box)(({ isDark }) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  padding: "4px 8px",
  borderRadius: "6px",
  border: "1px solid rgba(88,166,255,0.4)",
  backgroundColor: isDark ? "#243447" : "#DFECFE",
  boxShadow: isDark ? "0px 4px 2px rgba(0,0,0,0.25)" : "none",
  maxWidth: 220,
}));

const iconStyle = { height: "16px", width: "auto", flexShrink: 0 };

const FileName = styledComponent(Typography)(({ isDark }) => ({
  fontFamily: "Inter",
  fontSize: "12px",
  fontWeight: 400,
  color: isDark ? "#ECEFF3" : "#434950",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: 160,
}));

export default function DraggedFileChip({ isDark, file_name, file_type }) {
  const FileIcon = getFileTypeIcon(file_type);

  return (
    <ChipRoot isDark={isDark}>
      {FileIcon && <FileIcon style={iconStyle} />}
      <FileName isDark={isDark}>{file_name}</FileName>
    </ChipRoot>
  );
}
